module.exports = __webpack_public_path__ + "img/Poster3.42ca5601.png";